export default {
  myAccount: {
    profile: 'Perfil',
    pageTitle: 'Minha conta'
  }
}
